module.exports = __webpack_public_path__ + "img/kominfo.dcb52cca.png";